import React, { useState, useEffect } from 'react';

interface VideoPlayerProps {
  isDarkMode: boolean;
}

export const VideoPlayer: React.FC<VideoPlayerProps> = ({ isDarkMode }) => {
  const [videoUrl, setVideoUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchVideoUrl = async () => {
      try {
        const response = await fetch('/api/user?resource=video');
        
        if (!response.ok) {
          // If video is not configured, silently fail
          if (response.status === 404) {
            setLoading(false);
            return;
          }
          throw new Error('Failed to load video');
        }

        const data = await response.json();
        if (data.videoUrl) {
          setVideoUrl(data.videoUrl);
        }
      } catch (err) {
        console.error('Error loading video:', err);
        setError('Failed to load video');
      } finally {
        setLoading(false);
      }
    };

    fetchVideoUrl();
  }, []);

  // Don't render anything if there's no video URL or if still loading
  if (loading || !videoUrl) {
    return null;
  }

  // Don't render if there was an error (silently fail)
  if (error) {
    return null;
  }

  return (
    <div className={`w-full max-w-4xl mx-auto mt-32 mb-32 rounded-xl overflow-hidden shadow-2xl ${
      isDarkMode ? 'bg-gray-800' : 'bg-white'
    }`}>
      <video
        src={videoUrl}
        autoPlay
        loop
        muted
        playsInline
        className="w-full h-auto"
        onError={() => {
          console.error('Video failed to load');
          setError('Video failed to load');
        }}
      >
        Your browser does not support the video tag.
      </video>
    </div>
  );
};
